import React from "react";
import Button from '@mui/material/Button';
import PatientAction from "./patientActionButtons";


const Lifestyle = () => {
    return (
        <><PatientAction />
        <form>
            <div className="lifestyle-info" >
                <div className="mt-3 ml-4"> <h4>Lifestyle</h4></div>
                <div className="row" style={{ marginLeft:0, marginRight: 0, marginTop: 20 }}>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Smoking</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Smoking" />
                        </div>
                    </div>
                     <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Tobacco</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Tobacco" />
                        </div>
                    </div>
                   <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Alcohol</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Alcohol" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Blood Group</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Blood Group" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Diet</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Diet" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Water intake</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Water intake" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Excercise / Yoga</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Excercise / Yoga" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end mr-4 mb-3">
                <Button variant="outlined">Submit</Button>
            </div>
        </form>
        </>
    );
};

export default Lifestyle; 